export default __webpack_public_path__ + "static/media/pfbVisions.2f005fb1.jpg";